// extracted by mini-css-extract-plugin
export var carrierTab = "_4a-0";
export var carrierTabActive = "_4a-1 _4a-0";
export var carrierTabInactive = "_4a-2 _4a-0";
export var carrierTabLabel = "_4a-3";
export var carrierTabLabelActive = "_4a-4 _4a-3";
export var carrierTabLabelInactive = "_4a-5 _4a-3";
export var carrierTabPercentage = "_4a-6";
export var carrierTabPercentageActive = "_4a-7 _4a-6";
export var carrierTabPercentageInactive = "_4a-8 _4a-6";
export var carrierTabWinnable = "_4a-9";
export var carrierTabWinnableActive = "_4a-a _4a-9";
export var carrierTabWinnableInactive = "_4a-b _4a-9";
export var comparisonContainer = "_4a-d";
export var missingRateButton = "_4a-n";
export var missingRateButtonActive = "_4a-o _4a-n";
export var missingRateButtonInactive = "_4a-p _4a-n";
export var missingRateButtonLabel = "_4a-q";
export var missingRateButtonLabelActive = "_4a-r _4a-q";
export var missingRateButtonLabelInactive = "_4a-s _4a-q";
export var sidebar = "_4a-c";
export var strategyButton = "_4a-e";
export var strategyButtonActive = "_4a-f _4a-e";
export var strategyButtonDescription = "_4a-k";
export var strategyButtonDescriptionActive = "_4a-l _4a-k";
export var strategyButtonDescriptionInactive = "_4a-m _4a-k";
export var strategyButtonInactive = "_4a-g _4a-e";
export var strategyButtonLabel = "_4a-h";
export var strategyButtonLabelActive = "_4a-i _4a-h";
export var strategyButtonLabelInactive = "_4a-j _4a-h";
export var unitToggleButton = "_4a-t";
export var unitToggleButtonActive = "_4a-u _4a-t";
export var unitToggleButtonInactive = "_4a-v _4a-t";
export var unitToggleButtonLabel = "_4a-w";
export var unitToggleButtonLabelActive = "_4a-x _4a-w";
export var unitToggleButtonLabelInactive = "_4a-y _4a-w";